import { NavigationGuard } from "vue-router";
import { store } from "@/store";

export const roleGuard: NavigationGuard = async (to, from, next) => {
    const roleLevelRequirement = to.matched.find(route => route.meta.roleLevelRequirement)?.meta.roleLevelRequirement;

    if (roleLevelRequirement) {
        if (store.state.app.user == null) {
            await store.dispatch("app/getUser");
        }

        if (store.state.app.user &&
            store.state.app.user.role.toUpperCase()  === roleLevelRequirement.toUpperCase() ) {
            next();
        } else {
            next("/");
        }
    } else {
        next();
    }
};
